import {
  http,
  delay,
  HttpResponse,
} from 'msw';

import { createMockEndpoint } from '@/mocks/create-mock-endpoint';
import { BankPayTransactionDetailResponse } from '@/repositories/generated';

const response: BankPayTransactionDetailResponse = {
  accountMethod: '34',
  amount: 1000,
  storeId: undefined,
  storeName: undefined,
  terminalId: '8229200010001',
  terminalTransactionId: '00494',
  walletServiceName: '〇〇Pay',
  walletUserId: '244',
  externalUserId: 'test_user001',
  payEnterpriserId: 'BPR0000054',
  bankCode: '9999',
  branchCode: '123',
  chargeProcessingId: 'c123456',
  dealType: 'SALES',
  errorCode: 'E500099',
  errorMessage: '内部処理中にエラーが発生しました。再度お試しください',
  fixedBankbookMerchantName: '○○Pay',
  gwServiceProviderId: '-',
  merchantId: 'BMRS000044',
  merchantName: '〇〇〇〇',
  merchantTransactionId: '0000000000001202308085060',
  merchantUserId: 'ws1072',
  optionalBankbookMerchantName: '-',
  paymentTransactionId: 'e845b9a2-0few-4sd0-9551-25d9885tgf6',
  paymentType: 'NON_FACE_TO_FACE_CHARGE_OPEN',
  processingDate: '2023-04-23T00:00:00+09:00',
  refundFlag: 'ABNORMAL',
  refundedAmount: 1000,
  status: 'NORMAL',
  salesAmount: 1000,
  salesMerchantTransactionId: '0000000000001202308085060',
  salesTerminalId: '7329234350002',
  salesTerminalTransactionId: '01712',
  approverNum: '1234567',
};

export const bankpayDetail = http.get(
  createMockEndpoint('/bankpay_transaction/:walletServiceId/:merchantId/:merchantTransactionId'),
  async () => {
    await delay(500);
    return HttpResponse.json(response, { status: 200 });
  },
);
